<template>
<section id="forgot">
    <NavbarDefault selection route="/" />
    <el-progress :stroke-width="2" :color="getPrimaryColorHex.four" :show-text="false" :percentage="80" />
    <div class="container pt-0">
        <div class="row d-flex justify-content-center">
            <div class="col-12 mt-5 pt-4 px-4 d-flex justify-content-center">
                <div class="col-5">
                    <h2 :class="`text-center c-${getPrimaryColor}four bold`">Crie sua senha</h2>
                    <p class="c-ndarkfour text-center mb-4">
                        Crie agora a senha que você usará para acessar sua conta<br> {{ getWhiteLabel | capitalizeFirstLetter }} posteriormente.
                    </p>
                    <el-form :model="newPassword" ref="newPassword" @submit.native.prevent="createNewPassword">

                        <el-form-item prop="password" class="mb-4">
                            <h6 class="regular" :class="newPassword.password.length ? isSuccess : ''">
                                Senha
                            </h6>
                            <el-popover popper-class="item" :visible-arrow="true" placement="bottom-start" trigger="manual" content="Caps Lock ativado." v-model="popoverVisible">
                                <el-input
                                    slot="reference"
                                    :class="`${getPrimaryColor} ${newPassword.password.length ? isSuccess : ''}`"
                                    placeholder="Sua senha"
                                    native-type="password"
                                    v-model="newPassword.password"
                                    show-password
                                    @keydown.space.native.prevent
                                    @keydown.enter.native.prevent
                                    @keydown.native="checkCapsLockKey"
                                />
                            </el-popover>
                            <h6 v-if="newPassword.password.length" class="mt-1 password-strength-label regular" :class="
                                    this.checkPassword.passwordStrength > 3 ? 'c-green' : 'c-error'
                                ">
                                Força da senha:
                                {{
                                    this.checkPassword.passwordStrength > 3 ? 'Forte' : 'Fraco'
                                }}
                            </h6>
                        </el-form-item>


                        <div class="row mb-4">
                            <div class="col-12 mb-2">
                                <p class="c-ndarkfour medium">
                                    Sua senha deve ter:
                                </p>
                            </div>
                            <div class="col-6">
                                <p class="regular">
                                    <check-icon class="c-green" v-show="checkPassword.sixSuccess"></check-icon>
                                    <x-icon class="c-error" v-show="!checkPassword.sixSuccess"></x-icon>
                                    Mínimo de 6 caracteres;
                                </p>
                            </div>
                            <div class="col-6">
                                <p class="regular">
                                    <check-icon class="c-green" v-show="checkPassword.numberSuccess"></check-icon>
                                    <x-icon class="c-error" v-show="!checkPassword.numberSuccess"></x-icon>
                                    1 número;
                                </p>
                            </div>
                            <div class="col-6">
                                <p class="regular">
                                    <check-icon class="c-green" v-show="checkPassword.upperSuccess"></check-icon>
                                    <x-icon class="c-error" v-show="!checkPassword.upperSuccess"></x-icon>
                                    1 letra maiúscula;
                                </p>
                            </div>
                            <div class="col-6">
                                <p class="regular">
                                    <check-icon class="c-green" v-show="checkPassword.especialSuccess"></check-icon>
                                    <x-icon class="c-error" v-show="!checkPassword.especialSuccess"></x-icon>
                                    1 caractere especial.
                                </p>
                            </div>
                        </div>

                        <Button @click="createNewPassword" class="btn btn-blue w-100 justify-content-center" :disabled="!checkedPassword" :color="getPrimaryColor">
                            Confirmar
                        </Button>

                    </el-form>
                </div>
            </div>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
    <Footer />
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import Footer from '@/components/navigation/footer/Footer'
import FullLoading from '@/components/loading/FullLoading'
import validatePassword from '@/utils/validatePassword'
import removeMask from '@/utils/removeMask'
import setPassword from '@/api/setPassword'
import getAllCnpjs from '@/api/getAllCnpjs'
import selectCompany from '@/api/selectCompany'
import updateCompany from '@/api/updateCompany'

import {
    XIcon,
    CheckIcon,
} from 'vue-feather-icons';

export default {
    components: {
        NavbarDefault,
        XIcon,
        CheckIcon,
        Footer,
        FullLoading,
    },
    data() {
        return {
            newPassword: {
                password: '',
                verificationCode: this.$store.state.user.verificationCode,
            }
        }

    },
    methods: {
        checkCapsLockKey(key) {
            this.popoverVisible = key.getModifierState('CapsLock')
        },
        async createNewPassword() {
            const result = await setPassword({ partner: this.partner, ...this.newPassword }, this.$store.state.user.token)
            if (result.data.message == 'success' && result.data.ok) {
                this.$notify({
                    title: 'Senha criada com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false
                });
                await this.setCompany()
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        async setCompany() {
            const cnpjData = this.$store.state.register.company.cnpj
            await updateCompany(cnpjData.id, { cnpj: { intentUseCredit: cnpjData.intentUseCredit } })
            await getAllCnpjs()
            this.$store.commit('user/setLoading', true)
            if (this.$store.state.user.companys.length > 1) {
                this.$store.commit('user/setLoading', false)
                this.$router.push('/company/select')
            } else {
                const result = await selectCompany(removeMask(this.$store.state.user.cnpj), '1')
                this.$store.commit('user/setLoading', false)
                if (result.data.ok) {
                    window.location.href = `${this.getServiceUrls.MARKETPLACE}/home`
                }
            }
        },
    },
    computed: {
        checkPassword: function () {
            return validatePassword(this.newPassword.password)
        },
        checkedPassword: function () {
            return this.checkPassword.sixSuccess && this.checkPassword.numberSuccess && this.checkPassword.upperSuccess && this.checkPassword.especialSuccess
        },
        isSuccess: function () {
            return this.checkedPassword ? 'is-success' : 'is-error'
        },
        partner() {
            return this.getWhiteLabel
        }
    }
}
</script>

<style scoped>
.password-strength-label{
    font-weight: 400;
}

</style>
